import React, { useState } from "react";
import { FileBrowseComposite } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSources/FileBrowseComposite";
import { Checkbox, Divider, Flex, Select, Text } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

export const SAPTXTSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  let orgFile = config["orgfile"];
  let personFile = config["personfile"];
  let occFile = config["occfile"];
  let directory = config["datadir"];

  const [showApproved, setShowApproved] = useState(false);
  const kSAPOptions = [
    { value: 0, label: appstr("sapoption1") },
    { value: 1, label: appstr("sapoption2") },
    { value: 2, label: appstr("sapoption3") }
  ];
  const BuildSAPOptions = () => {
    let options = [];
    let headers = kSAPOptions;

    for (let header of headers) {
      let option = {
        value: header.value,
        label: header.label,
        clickHandler: e => HandleFieldSelect(e)
      };
      options.push(option);
    }
    return options;
  };
  const HandleFieldSelect = option => {
    onChange({ ...config, SAPOption: option.value });
  };

  const handleToggle = () => {
    setShowApproved(!showApproved);
  };

  return (
    <Flex direction={"column"} gap={"12px"} width={"100%"}>
      <Flex direction={"column"}>
        <Text size={"small"} modifier={"bold"}>
          {appstr("Org unit file") + ":  "}
        </Text>
        <FileBrowseComposite
          file={orgFile}
          directory={directory}
          includeBrowse
          onChange={onChange}
          config={config}
          importType={importType}
          chartConfig={chartConfig}
          index={index}
          orgUnitFile
        />
      </Flex>
      <Flex direction={"column"}>
        <Text size={"small"} modifier={"bold"}>
          {appstr("Position file") + ": "}
        </Text>
        <FileBrowseComposite
          file={personFile}
          directory={directory}
          includeBrowse
          onChange={onChange}
          config={config}
          importType={importType}
          chartConfig={chartConfig}
          index={index}
          positionFile
        />
      </Flex>
      <Divider />
      <Flex justifyContent={"space-between"} gap={"8px"} direction={"row"} width={"100%"}>
        <Select
          listWidth={"large"}
          placeholder={"Select option..."}
          selectSize={"medium"}
          inputOnly={false}
          label={appstr("SAP OrgUnit Chart Options")}
          options={BuildSAPOptions()}
          value={config["SAPOption"]}
        />
      </Flex>
      <Flex justifyContent={"space-between"} gap={"8px"}>
        <Checkbox
          id={"is-legacy"}
          label={appstr("Use approved positions table")}
          size={"medium"}
          onToggle={handleToggle}
          checked={showApproved}
        />
      </Flex>
      {showApproved && (
        <>
          <Divider />
          <Flex direction={"column"}>
            <Text size={"small"} modifier={"bold"}>
              {appstr("Approved positions file") + ": "}
            </Text>
            <FileBrowseComposite
              file={occFile}
              directory={directory}
              includeBrowse
              onChange={onChange}
              config={config}
              importType={importType}
              chartConfig={chartConfig}
              index={index}
              approvedPositionsFile
            />
          </Flex>
        </>
      )}
    </Flex>
  );
};
